import React, { Component } from "react";
import { Field, Form, withFormik } from "formik";
import * as Yup from "yup";
import Aux from "../../../../../hoc/Auxilary";
import SelectionFields from "../../../../../hoc/UI/SelectionFields/SelectionFields";
import { Button } from "rsuite";

class ContractDBEForm extends Component {
  render() {
    const validAndHandle = (func, values) => {
      this.props.validateForm().then(errors => {
        if (Object.keys(errors).length !== 0) {
          this.props.setFieldTouched("proj_contract_id", true);
          console.log("cannot submit! Validation failed", errors);
        } else {
          values.project_id = this.props.projectID;
          func(values);
          this.props.resetForm();
          this.props.toggleSmallModalHandler();
        }
      });
    };

    return (
      <Form>
        {" "}
        <fieldset disabled={this.props.disabled}>
          {" "}
          <div
            onClick={this.props.toggleSmallModalHandler}
            style={{ color: "red", float: "right", cursor: "pointer" }}
          >
            x
          </div>
          <small className={"d-block col-12"}>
            <span style={{ color: "red" }}>*</span> required
          </small>
          <label className="col-12">
            CUF Review Number
            <Field
              className="form-control-sm form-control"
              name={"cuf_review_number"}
              value={this.props.values.cuf_review_number || ""}
            />
          </label>
          <label className="col-12">
            Display Order
            <Field
              className="form-control-sm form-control"
              name={"display_order"}
              value={this.props.values.display_order || null }
            />
          </label>
          <label className="col-12">
            DBE Commitment At Time Of Award
            <Field
              className="form-control-sm form-control"
              name={"dbe_commitment_at_time_of_award"}
              value={this.props.values.dbe_commitment_at_time_of_award || ""}
            />
          </label>
          <label className="col-12">
            DBE Goal Achieved
            <Field
              className="form-control-sm form-control"
              name={"dbe_goal_achieved"}
              value={this.props.values.dbe_goal_achieved || ""}
            />
          </label>
          <label className="col-12">
            DBE Number Utilized
            <Field
              className="form-control-sm form-control"
              name={"dbe_number_utilized"}
              value={this.props.values.dbe_number_utilized || ""}
            />
          </label>
          <div>
            <SelectionFields
              showError={
                this.props.errors.proj_contract_id &&
                this.props.touched.proj_contract_id
              }
              size={"col-12"}
              id={"proj_contract_id"}
              url={`proj_contract/project_id/${this.props.projectID}`}
              showElem={"contract_name"}
              label={"Contract"}
              value={this.props.values["proj_contract_id"] || "default"}
              isRequired={true}
              errorMessage={
                this.props.errors.proj_contract_id &&
                this.props.touched.proj_contract_id && (
                  <small className={"text-danger"}>
                    {this.props.errors.proj_contract_id}
                  </small>
                )
              }
            />
            {this.props.errors.proj_contract_id &&
              this.props.touched.proj_contract_id && (
                <small className={"text-danger"}>
                  {this.props.errors.proj_contract_id}
                </small>
              )}
          </div>
          <label className="col-12">
            Contract DBE Compliance
            <Field
              component={"textarea"}
              className="form-control-sm form-control"
              name={"contract_dbe_compliance"}
              value={this.props.values.contract_dbe_compliance || ""}
            />
          </label>
          <label className="col-12">
            Contract DBE OJT Goal
            <Field
              component={"textarea"}
              className="form-control-sm form-control"
              name={"contract_dbe_ojt_goal"}
              value={this.props.values.contract_dbe_ojt_goal || ""}
            />
          </label>
          <label className="col-12">
            Contract DBE Penalty
            <Field
              component={"textarea"}
              className="form-control-sm form-control"
              name={"contract_dbe_penalty"}
              value={this.props.values.contract_dbe_penalty || ""}
            />
          </label>
          <label className="col-12">
            DBE OJT Performance
            <Field
              component={"textarea"}
              className="form-control-sm form-control"
              name={"dbe_ojt_performance"}
              value={this.props.values.dbe_ojt_performance || ""}
            />
          </label>
          <label className="col-12">
            Notes
            <Field
              component={"textarea"}
              rows={4}
              className="form-control-sm form-control"
              name={"notes"}
              value={this.props.values.notes || ""}
            />
          </label>
          <label className="col-12">
            Proposer DBE Commitment
            <Field
              component={"textarea"}
              className="form-control-sm form-control"
              name={"proposer_dbe_commitment"}
              value={this.props.values.proposer_dbe_commitment || ""}
            />
          </label>
          <label className="col-12">
            RFP DBE
            <Field
              component={"textarea"}
              className="form-control-sm form-control"
              name={"rfp_dbe"}
              value={this.props.values.rfp_dbe || ""}
            />
          </label>
          <label className="col-12">
            RFQ DBE
            <Field
              component={"textarea"}
              className="form-control-sm form-control"
              name={"rfq_dbe"}
              value={this.props.values.rfq_dbe || ""}
            />
          </label>
          <label className="col-12">
            RFP DBE Goal
            <Field
              className="form-control-sm form-control"
              name={"rfp_dbe_goal"}
              value={this.props.values.rfp_dbe_goal || ""}
            />
          </label>
        </fieldset>
        {this.props.disabled ? (
          <Button
            className={"ml-2"}
            type="button"
            onClick={this.props.toggleSmallModalHandler}
          >
            Cancel
          </Button>
        ) : (
          <div>
            {!this.props.currentContractDBE ? (
              <Aux>
                <Button
                  color={"blue"}
                  type="button"
                  onClick={() => {
                    validAndHandle(this.props.add, this.props.values);
                  }}
                >
                  Submit
                </Button>
                <Button
                  color="red"
                  className="ml-2"
                  type="button"
                  onClick={this.props.handleReset}
                >
                  Reset
                </Button>
              </Aux>
            ) : (
              <Aux>
                <Button
                  color={"blue"}
                  type="button"
                  onClick={() => {
                    validAndHandle(this.props.update, this.props.values);
                  }}
                >
                  Update
                </Button>
                <Button
                  color="red"
                  className="ml-2"
                  type="button"
                  onClick={this.props.handleReset}
                >
                  Reset
                </Button>
              </Aux>
            )}
            <Button
              className={"ml-2"}
              type="button"
              onClick={this.props.toggleSmallModalHandler}
            >
              Cancel
            </Button>
          </div>
        )}
      </Form>
    );
  }
}

var contractDBESchema = Yup.object().shape({
  proj_contract_id: Yup.string().required()
});

export default withFormik({
  validationSchema: contractDBESchema,
  enableReinitialize: true,

  mapPropsToValues({ currentContractDBE }) {
    return {
      ...currentContractDBE
    };
  }
})(ContractDBEForm);
